const ku = {
  navbar: {
    trackCase: "شوێنپێی کەیسێک",
  },
};

export default ku;
